import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL =
//   currentDomain === "localhost" ||
//   currentDomain === "127.0.0.1" ||
//   currentDomain === "aiconnect.com.tr" ||
//   currentDomain === "demo.aiconnect.com.tr"
//     ? "https://apis.aiconnect.com.tr"
//     : `https://apis.${currentDomain}`;

const DashboardService = {
  getExtensionStatus: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      status: data.status,
    });
    return axios.get(
      `${API_BASE_URL}/dashboard/getExtensionStatus?${params.toString()}`
    );
  },

  kickExtension: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/kickExtension`, data);
  },

  sendLogs: (data) => {
    return axios.post(`${API_BASE_URL}/logs/setDashboard`, data);
  },
  refreshphone: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/refreshphone`, data);
  },

  getTotalCount: (data) => {
    const params = new URLSearchParams(data);
    return axios.get(
      `${API_BASE_URL}/dashboard/getTotalCount?${params.toString()}`
    );
  },

  getbreak: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/getbreak`, data);
  },
  agentloginlog: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/agentloginlog`, data);
  },
  agentlogoutlog: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/agentlogoutlog`, data);
  },
  getDocument: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/getDocument`, data);
  },
  getCallHistory: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      status: data.status,
      params: data.params,
    });
    return axios.get(
      `${API_BASE_URL}/dashboard/getCallHistory?${params.toString()}`
    );
  },
  insertLogInfo: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/insertLogInfo`, data);
  },

  getAgentStatus: (data) => {
    const params = new URLSearchParams(data);
    return axios.get(
      `${API_BASE_URL}/dashboard/getAgentStatus?${params.toString()}`
    );
  },

  getTotalTime: (data) => {
    const params = new URLSearchParams(data);
    return axios.get(
      `${API_BASE_URL}/dashboard/getTotalTime?${params.toString()}`
    );
  },

  getNewAccountList: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/getNewAccountList`, data);
  },
  
  getRejectReason: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/getRejectReason`, data);
  },

  generalLog: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/generalLog`, data);
  },

  insertRejectCall: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/insertRejectCall`, data);  
  },
  agentInScreen: (data) => {
    return axios.post(`${API_BASE_URL}/dashboard/agentInScreen`, data);  
  }
};

export default DashboardService;
